import { create } from 'zustand';

export const useReportArchiveStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'archivedAt',
        sortOrder: 'desc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((state) => ({
        searchParams: { ...state.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
}));
